export default "__VITE_ASSET__DOzHwihh__"